import React, { useState, useEffect } from 'react';
import login from './login.module.css';
import { useForm } from 'react-hook-form';
import { CiMail } from 'react-icons/ci';
import { forgotPassword } from '../../Services/APIrequests';
import { SuccessSwal, warningSwal } from '../../Util/Toast';
import { setAuthToken } from '../../Services/config';
import { FaSpinner } from 'react-icons/fa'; // Import spinner icon

const Forgetpassword = () => {
    const [loading, setLoading] = useState(false); // State to track loading status
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        const token = sessionStorage.getItem('token');
        setAuthToken(token);
    }, []);

    // Handle form submission
    const onSubmit = async (data) => {
        setLoading(true); // Set loading to true when form is submitted
        try {
            const { email } = data;
            const requestBody = {
                email: email,
            };
            const response = await forgotPassword(requestBody);
            SuccessSwal('Success', response?.data?.message);
        } catch (error) {
            warningSwal('Error', error.response?.data?.message);
        } finally {
            setLoading(false); // Set loading to false when request is completed
        }
    };

    return (
        <div className={login.Comman_Container}>
            <div className={login.bgcontainer}>
                <div className={login.header_section}>
                    <h1 className={login.header_text}>Forgot Password?</h1>
                    <p className={login.subheader_text}>Reset password with Koher</p>
                </div>
                <div className={login.form_section}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={login['form-control']}>
                            <label htmlFor="email">Email</label>
                            <div className={login.input_container}>
                                <input
                                    type="email"
                                    placeholder="Type your email"
                                    {...register('email', {
                                        required: 'Email is required!',
                                        pattern: {
                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                            message: 'Enter a valid email address!',
                                        },
                                    })}
                                />
                                <p className={login.icon}>
                                    <CiMail size={22} stroke={5} />
                                </p>
                            </div>
                            {errors?.EmailID && (
                                <p className={login.error}>{errors?.EmailID?.message}</p>
                            )}
                        </div>
                        <p className={login.swipetext}>Link will be sent to the entered email ID</p>
                        <input
                            type="submit"
                            value={loading ? '' : 'Send Reset Link'}
                            disabled={loading} // Disable button while loading
                        />
                        {loading && (
                            <FaSpinner className={login.loader} size={24} spin /> // Show loader icon
                        )}
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Forgetpassword;
